import { Outlet } from 'react-router-dom'

import styles from './LoginPage.module.css'

export function AuthLayout() {
  return (
    <main className={styles.page}>
      <section className={styles.brandPanel} aria-label="About Flio">
        <div className={styles.brand}>
          <span className={styles.brandLogo}>
            <img src="/brand/flio-logo.png" alt="Flio" />
          </span>
          <span>
            <strong>Flio</strong>
            <small>AI operations for modern clinics</small>
          </span>
        </div>
        <div className={styles.brandCopy}>
          <span className={styles.eyebrow}>Clinic workspace</span>
          <h1>Care starts with a clear conversation.</h1>
          <p>
            A focused workspace for your clinic team, designed around the
            conversations that need attention.
          </p>
        </div>
      </section>
      <section className={styles.formPanel}>
        <Outlet />
      </section>
    </main>
  )
}
